import React, { useRef, useState } from "react";
import ReactPlayer from "react-player";

type VideoImagePostProps = {
  handleClick: (index: number) => void;
  allMediaUrls: any[];
  thumbnail?: string[];
};
const VideoImagePost: React.FC<VideoImagePostProps> = ({
  handleClick,
  allMediaUrls,
  thumbnail,
}) => {
  const [playing, setPlaying] = useState(false);
  const playerRef = useRef(null); // Create a ref using useRef
  const play = () => setPlaying(true);
  const pause = () => setPlaying(false);
  const isBlobUrl = (url: string) => url.startsWith("blob:") && !url.startsWith("data:image/jpeg;");
  const _thumbnail = thumbnail || []
// console.log(_thumbnail);

  return (
    <div className="flex border w-full relative">
      {allMediaUrls && allMediaUrls.length > 4 ? (
        <div className="grid w-full h-[100px]">
          {allMediaUrls?.map((media, index) => (
            <div
              className="border relative flex flex-col cursor-pointer h-auto"
              onClick={() => handleClick(index)}
              key={index * 2}
            >
              {isBlobUrl(media) ? (
                <ReactPlayer
                  ref={playerRef}
                  key={index}
                  url={media}
                  width="100%"
                  height="100px"
                  controls={true}
                  playing={playing}
                  onPlay={play}
                  onPause={pause}
                  volume={1}
                  muted={true}
                  light={_thumbnail[index]}
                />
              ) : (
                <img
                  id="imga"
                  src={media}
                  alt=""
                  className="w-full object-cover h-auto object-center"
                />
              )}
            </div>
          ))}
        </div>
      ) : allMediaUrls && allMediaUrls?.length > 3 ? (
        <div className="grid grid-cols-2 w-full">
          {allMediaUrls?.map((media, index) => (
            <div
              className={`flex w-full border border-solid relative overflow-hidden cursor-pointer`}
              onClick={() => handleClick(index)}
              key={index}
            >
              {isBlobUrl(media) ? (
                <ReactPlayer
                  ref={playerRef}
                  key={index}
                  url={media}
                  width="100%"
                  height="100%"
                  controls={true}
                  playing={playing}
                  onPlay={play}
                  onPause={pause}
                  volume={1}
                  muted={true}
                  light={_thumbnail[index]}
                />
              ) : (
                <img
                  id="imga"
                  src={media}
                  alt=""
                  className="w-full object-cover h-auto object-center"
                />
              )}
            </div>
          ))}
        </div>
      ) : (
        <div className="flex w-full">
          {allMediaUrls?.length === 1
            ? allMediaUrls.map((media, index) => (
                <div className="flex w-full h-auto mb-8" key={index + 44}>
                  <div
                    className="w-full relative cursor-pointer h-auto overflow-hidden"
                    onClick={() => handleClick(index)}
                  >
                    {isBlobUrl(media) ? (
                      <ReactPlayer
                        ref={playerRef}
                        key={index}
                        url={media}
                        width="100%"
                        height="100%"
                        controls={true}
                        playing={playing}
                        onPlay={play}
                        onPause={pause}
                        volume={1}
                        muted={true}
                        light={_thumbnail[index]}
                      />
                    ) : (
                      <img
                        id="imga"
                        src={media}
                        alt=""
                        className="w-full object-cover h-full object-center"
                      />
                    )}
                  </div>
                </div>
              ))
            : allMediaUrls?.length === 2
            ? allMediaUrls?.map((media, index) => (
                <div className="flex w-full" key={index * 99}>
                  <div
                    className="h-[176px] cursor-pointer flex justify-between gap-1 w-full overflow-hidden border-2 relative"
                    onClick={() => handleClick(index)}
                  >
                    {isBlobUrl(media) ? (
                      <ReactPlayer
                        ref={playerRef}
                        key={index}
                        url={media}
                        width="100%"
                        height="100%"
                        controls={true}
                        playing={playing}
                        onPlay={play}
                        onPause={pause}
                        volume={1}
                        muted={true}
                        light={_thumbnail[index]}
                      />
                    ) : (
                      <img
                        id="imga"
                        src={media}
                        alt=""
                        className="w-full object-cover h-full object-center"
                      />
                    )}
                  </div>
                </div>
              ))
            : allMediaUrls?.length === 3 && (
                <div className="flex w-full">
                  {allMediaUrls.map(
                    (media, index) =>
                      index === 0 && (
                        <div className="flex w-full" key={index * 20}>
                          <div
                          className="w-full relative lg:h-[400px] h-[308px] overflow-hidden cursor-pointer"
                          onClick={() => handleClick(index)}
                          >
                            {isBlobUrl(media) ? (
                              <ReactPlayer
                                ref={playerRef}
                                key={index}
                                url={media}
                                width="100%"
                                height="100%"
                                controls={true}
                                playing={playing}
                                onPlay={play}
                                onPause={pause}
                                volume={1}
                                muted={true}
                                light={_thumbnail[index]}
                              />
                            ) : (
                              <img
                                id="imga"
                                src={media}
                                alt=""
                                className="w-full object-cover h-full object-center"
                              />
                            )}
                          </div>
                        </div>
                      )
                  )}
                  <div className="grid grid-rows-2 h-auto w-full overflow-hidden">
                    {allMediaUrls?.map(
                      (media, index) =>
                        index !== 0 && (
                          <div
                            className="flex w-full overflow-hidden relative h-auto"
                            key={index + 33}
                          >
                            <div
                              className="w-full flex-1 border flex cursor-pointer"
                              onClick={() => handleClick(index)}
                            >
                              {isBlobUrl(media) ? (
                                <ReactPlayer
                                  ref={playerRef}
                                  key={index}
                                  url={media}
                                  width="100%"
                                  height="100%"
                                  controls={true}
                                  playing={playing}
                                  onPlay={play}
                                  onPause={pause}
                                  volume={1}
                                  muted={true}
                                  light={_thumbnail[index]}
                                />
                              ) : (
                                <img
                                  id="imga"
                                  src={media}
                                  alt=""
                                  className="w-full object-cover h-full object-center"
                                />
                              )}
                            </div>
                          </div>
                        )
                    )}
                  </div>
                </div>
              )}
        </div>
      )}
    </div>
  );
};

export default VideoImagePost;
